import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  CircularProgress,
  IconButton,
  Checkbox,
  Snackbar,
  Fade,
  Slide,
  Chip,
  Card,
  CardContent,
  RadioGroup,
  FormControlLabel,
  Radio,
  Avatar,
  alpha,
} from "@mui/material";
import {
  ArrowBack,
  Edit,
  Delete,
  CalendarToday,
  Assignment,
  Download,
  Visibility,
} from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  decryptAppId,
  decryptText,
  encryptText,
  encryptAppId,
} from "../../../utils/encryption";
import acProcessService from "../../../services/acProcessService";
import axios from "axios";
import s3Utils from "../../../utils/s3Utils";
import FileUploadComponent from "../../../components/FileUploadComponent";
import CertificateDialog from "../../../components/certificate/CertificateDialog";
import CommonAPIService from "../../../services/commonAPIService";
import dayjs from "dayjs";
import { date } from "yup";
import { mt } from "date-fns/locale";
const { generateCommunicationLetter } =
  await import("../../../components/certificate/CommunicationLetterGenerator");
const { generateDecisionLetter } =
  await import("../../../components/certificate/DecisionLetterGenerator");


// Hardcoded AC Type options
const acTypeOptions = [
  { value: "0", label: "-----Select-----" },
  { value: "SEC", label: "SEC" },
  { value: "CAT", label: "CAT" },
  { value: "CAM", label: "CAM" },
  { value: "CAC", label: "CAC" },
  { value: "SAC", label: "SAC" },
  { value: "CAT (Integrated)", label: "CAT (Integrated)" },
  { value: "PTP", label: "PTP" },
  { value: "RMP", label: "RMP" },
  { value: "Review Committee", label: "Review Committee" },
];

// Color definitions
const colors = {
  primary: {
    main: "#667eea",
    dark: "#5a67d8",
  },
  secondary: {
    main: "#764ba2",
    dark: "#5a3780",
  },
};

const ACProcess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Get encrypted parameters from URL
  const encryptedAppId = searchParams.get("appId");
  const encryptedOrgId = searchParams.get("orgId");
  const encryptedAssessmentId = searchParams.get("assessmentId");

  // Decrypt parameters
  const appIdFromUrl = encryptedAppId ? decryptAppId(encryptedAppId) : null;
  const orgIdFromUrl = encryptedOrgId ? decryptText(encryptedOrgId) : null;
  const assessmentIdFromUrl = encryptedAssessmentId
    ? decryptText(encryptedAssessmentId)
    : null;

  // State management
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [appId, setAppId] = useState(appIdFromUrl);
  const [orgId, setOrgId] = useState(orgIdFromUrl);
  const [assessmentId, setAssessmentId] = useState(assessmentIdFromUrl);
  const [application, setApplication] = useState(null);
  const [stage, setStage] = useState("");

  // Date Selection State
  const [showChooseDate, setShowChooseDate] = useState(false);
  const [ddlTypeOfAc, setDdlTypeOfAc] = useState("0");
  const [ddlDate, setDdlDate] = useState("0");
  const [ddlDateTo, setDdlDateTo] = useState("0");
  const [txtRemarks, setTxtRemarks] = useState("");
  const [dateOptions, setDateOptions] = useState([]);
  const [dateToOptions, setDateToOptions] = useState([]);
  const [repeaterData, setRepeaterData] = useState([]);
  const [showDateDiv, setShowDateDiv] = useState(true);
  const [showRepeaterDiv, setShowRepeaterDiv] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  // PT Plan states
  const [uploadedPtPlanFile, setUploadedPtPlanFile] = useState(null);
  const [ptPlanUploaded, setPtPlanUploaded] = useState(false);

  // Modal States
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [txtPassword, setTxtPassword] = useState("");

  // Send To joint Director States
  const [showSendToDirectorModal, setShowSendToDirectorModal] = useState(false);
  const [directorList, setDirectorList] = useState([]);
  const [selectedDirector, setSelectedDirector] = useState("0");
  const [directorPassword, setDirectorPassword] = useState("");
  const [loadingDirectors, setLoadingDirectors] = useState(false);

  // Edit Certificate Password States
  const [showEditCertificateModal, setShowEditCertificateModal] =
    useState(false);
  const [editCertificatePassword, setEditCertificatePassword] = useState("");

  // Final Status State
  const [showFinalStatus, setShowFinalStatus] = useState(false);
  const [ddlStatus, setDdlStatus] = useState("0");
  const [momFileData, setMomFileData] = useState(null);

  // Certificate related states
  const [showDivC, setShowDivC] = useState(false);
  const [rblCertNo, setRblCertNo] = useState("");
  const [showDivCertno, setShowDivCertno] = useState(false);
  const [txtBoxCert, setTxtBoxCert] = useState("");
  const [newprefix, setNewprefix] = useState("");
  const [txtCertificateNo, setTxtCertificateNo] = useState("");
  const [showGenerateCertModal, setShowGenerateCertModal] = useState(false);
  const [newCertificateGenerateAPI, setNewCertificateGenerateAPI] = useState(false);
  const [txtGeneratePassword, setTxtGeneratePassword] = useState("");
  const [reCertificateNo, setReCertificateNo] = useState(null);

  // Certificate Dialog state
  const [showCertificateDialog, setShowCertificateDialog] = useState(false);

  // Date related states
  const [showDivIssueDate, setShowDivIssueDate] = useState(false);
  const [txtIssueDate, setTxtIssueDate] = useState("");
  const [showDivToDate, setShowDivToDate] = useState(false);
  const [txtToDate, setTxtToDate] = useState("");
  const [showDivAmendment, setShowDivAmendment] = useState(false);
  const [txtAmendmentDate, setTxtAmendmentDate] = useState("");
  const [amendmentChoice, setAmendmentChoice] = useState("");

  // Activity related states
  const [showDivNextDueActivity, setShowDivNextDueActivity] = useState(false);
  const [ddlNextDueActivity, setDdlNextDueActivity] = useState("0");
  const [showDivExpectedDate, setShowDivExpectedDate] = useState(false);
  const [txtExpectedDate, setTxtExpectedDate] = useState("");

  // File upload states
  const [iacFileInState, setIacFileInState] = useState("");
  const [uploadedIACFile, setUploadedIACFile] = useState(null);
  const [fileUploadKey, setFileUploadKey] = useState(0);

  // Remarks states
  const [showDivRemarks, setShowDivRemarks] = useState(false);
  const [txtRemark, setTxtRemark] = useState("");
  const [showDivShowcauseRemarks, setShowDivShowcauseRemarks] = useState(false);
  const [txtShowcauseRemarks, setTxtShowcauseRemarks] = useState("");

  // Discipline states
  const [showDivDiscipline, setShowDivDiscipline] = useState(false);
  const [disciplines, setDisciplines] = useState([]);
  const [selectedDisciplines, setSelectedDisciplines] = useState([]);

  // Assessment states
  const [showDivReAssessType, setShowDivReAssessType] = useState(false);
  const [rbAssesstype, setRbAssesstype] = useState("");

  // Adverse decision states
  const [showAdverseDecision, setShowAdverseDecision] = useState(false);
  const [rbCoolingPeriod, setRbCoolingPeriod] = useState("0");
  const [txtCollingPeriod, setTxtCollingPeriod] = useState("");

  // Other states
  const [showDivRejctdRmrk, setShowDivRejctdRmrk] = useState(false);
  const [txtRejectedRemarks, setTxtRejectedRemarks] = useState("");
  const [showLnkFinal, setShowLnkFinal] = useState(false);
  const [showLnkGenerateBtn, setShowLnkGenerateBtn] = useState(false);
  const [showLnkProcceedforDecision, setShowLnkProcceedforDecision] =
    useState(false);
  const [showHlDecision, setShowHlDecision] = useState(false);
  const [showDecisionModal, setShowDecisionModal] = useState(false);

  // Decision Process States
  const [communicationSubject, setCommunicationSubject] = useState("");
  const [communicationBody, setCommunicationBody] = useState("");
  const [communicationLetterDate, setCommunicationLetterDate] = useState("");
  const [decisionPassword, setDecisionPassword] = useState("");
  const [showDecisionPasswordModal, setShowDecisionPasswordModal] =
    useState(false);
  const [sendLetterPassword, setSendLetterPassword] = useState("");
  const [showSendLetterModal, setShowSendLetterModal] = useState(false);
  const [advisoryList, setAdvisoryList] = useState([]);
  const [hasDecisionData, setHasDecisionData] = useState(false);

  // Scope data for certificate
  const [scopeData, setScopeData] = useState(null);
  const [certificateMainData, setCertificateMainData] = useState(null);
  const [loadingScopeData, setLoadingScopeData] = useState(false);
  const [scfData, setScfData] = useState(null);

  // Certificate Trail States
  const [showCertificateTrailModal, setShowCertificateTrailModal] =
    useState(false);
  const [certificateTrailData, setCertificateTrailData] = useState([]);
  const [loadingTrailData, setLoadingTrailData] = useState(false);
  const [hasTrailData, setHasTrailData] = useState(false);

  // Encrypted assessment ID from URL

  // Snackbar State
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Check if Certificate Trail Data exists
  const checkTrailDataAvailability = async () => {
    if (!appId) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/ScopeURlTrail`,
        { params: { appid: appId } },
      );

      if (
        response.data &&
        response.data.isstatus &&
        response.data.trail &&
        response.data.trail.length > 0
      ) {
        setHasTrailData(true);
        setCertificateTrailData(response.data.trail);
      } else {
        setHasTrailData(false);
      }
    } catch (error) {
      console.error("Error checking certificate trail availability:", error);
      setHasTrailData(false);
    }
  };

  // Handle opening certificate trail modal
  const handleOpenCertificateTrail = () => {
    checkTrailDataAvailability();
    setShowCertificateTrailModal(true);
  };

  // Handle closing certificate trail modal
  const handleCloseCertificateTrail = () => {
    setShowCertificateTrailModal(false);
  };

  // Handle viewing/downloading PDF from trail
  const handleViewTrailDocument = (url) => {
    if (url && url.startsWith("http")) {
      window.open(url, "_blank");
    } else {
      showSnackbar("Invalid document URL", "error");
    }
  };

  // Fetch Directors/CEO List
  const fetchDirectorsList = async () => {
    try {
      setLoadingDirectors(true);
      const response = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/ceolist`,
        {
          params: {
            appid: appId,
            usertypeid: 9,
          },
        },
      );

      if (response.data && response.data.ceo) {
        setDirectorList(response.data.ceo);
      } else {
        setDirectorList([]);
      }
    } catch (error) {
      console.error("Error fetching directors list:", error);
      showSnackbar("Error loading directors list", "error");
      setDirectorList([]);
    } finally {
      setLoadingDirectors(false);
    }
  };

  // Handle Send To Joint Director
  const handleSendToDirector = async () => {
    try {
      // Validation
      if (selectedDirector === "0") {
        showSnackbar("Please select a director", "warning");
        return;
      }

      if (!directorPassword.trim()) {
        showSnackbar("Please enter password", "warning");
        return;
      }

      // Verify password
      const orgId = localStorage.getItem("orgId");
      const passwordResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/verify-password`,
        {
          orgId: orgId,
          password: directorPassword,
        },
      );

      if (!passwordResponse.data.success) {
        showSnackbar("Invalid password", "error");
        return;
      }

      // Send to joint director API call
      const payload = {
        forwardto: selectedDirector,
        appid: appId.toString(),
        updatedby: orgId,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/sendtodirector`,
        payload,
      );

      showSnackbar("Application successfully sent to director", "success");
      setShowSendToDirectorModal(false);
      setSelectedDirector("0");
      setDirectorPassword("");

      // Refresh page or redirect
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error("Error sending to director:", error);
      showSnackbar(
        error.response?.data?.message ||
          "Error sending to director. Please try again.",
        "error",
      );
    }
  };

  // Open Send To joint Director Modal
  const handleOpenSendToDirector = () => {
    fetchDirectorsList();
    setShowSendToDirectorModal(true);
  };

  // Decision Process Handlers
  const loadDecisionData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Getdecision`,
        {
          params: {
            appid: appId,
            orgid: orgId,
          },
        },
      );

      if (response.data) {
        setCommunicationSubject(response.data.subject || "");
        setCommunicationBody(response.data.body || "");
        setCommunicationLetterDate(response.data.date || "");
        // Check if both subject and body exist
        const hasData = !!(response.data.subject && response.data.body);
        setHasDecisionData(hasData);
      } else {
        setHasDecisionData(false);
      }
    } catch (err) {
      console.error("Error loading decision data:", err);
      setHasDecisionData(false);
    }
  };

  const loadCommunicationData = async (appId, orgId) => {
    try {
      const commResponse = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/GetCommunication`,
        {
          params: { appid: appId, orgid: orgId },
        },
      );

      const subject = commResponse.data?.subject || "";
      const body = commResponse.data?.body || "";
      const date = commResponse.data?.date || "";
      // Return the data for immediate use
      return {
        subject,
        body,
        date,
      };
    } catch (err) {
      console.error("Error loading communication data:", err);
      return {
        subject: "",
        body: "",
        date: "",
      };
    }
  };

  // Handle View Communication Letter
  const handleViewScopeReport = () => {
    // Create encrypted parameters for the scope report URL
    const scopeReportUrl = `/main/do/form72?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}&assessmentId=${encryptText(assessmentId)}`;
    // Open in new tab
    window.open(scopeReportUrl, "_blank", "noopener,noreferrer");
  };
  const handleViewCommunicationLetter = async () => {
    try {
      showSnackbar("Generating communication letter...", "info");

      const communicationData = await loadCommunicationData(appId, orgId);

      if (!application) {
        showSnackbar(
          "Application data not loaded. Please wait and try again.",
          "warning",
        );
        return;
      }

      const letterData = {
        applicationNo: application.ApplicationNo || "N/A",
        letterDate: communicationData.date
          ? new Date(communicationData.date).toLocaleDateString("en-GB")
          : "",
        contactPerson: application.ContactPerson || "N/A",
        laboratoryName: application.LaboratoryName || "N/A",
        address: application.Address || "N/A",
        extAddress: application.ExtAddress || "N/A",
        mobile: application.ContactMobile || "N/A",
        email: application.ContactEmail || "N/A",
        subject: communicationData.subject || "N/A",
        body: communicationData.body || "N/A",
        advisoryList: advisoryList || [],
        doName: application.DoName || "N/A",
        doEmail: application.DoEmail || "N/A",
        showAdverseNote: false,
        showNewAddress: new Date() > new Date("2025-07-18"),
      };

      await generateCommunicationLetter(letterData);
      showSnackbar("Communication letter downloaded successfully", "success");
    } catch (err) {
      console.error("Error generating communication letter:", err);
      showSnackbar("Failed to generate communication letter", "error");
    }
  };

  // Handle Form 11
  // const handleForm11 = () => {
  //   const encryptedappid = encryptAppId(appId.toString());
  //   const encryptedorgid = encryptText(orgId.toString());
  //   const form11url = `/main/do/form11?appId=${encryptedappid}&orgId=${encryptedorgid}`;
  //   window.open(form11url, "_blank");
  // };

  const handleForm11 = async () => {
      const response = await CommonAPIService.getAssessmentSendToNABLDate(appId);
      if (response.success && response.data) {
        const encryptedappid = encryptAppId(appId.toString());
        const encryptedorgid = encryptText(orgId.toString());
        if (response.data.isDisplayNew) {
          const form11url = `/main/do/form11-new?appId=${encryptedappid}&orgId=${encryptedorgid}`;
          window.open(form11url, "_blank");
        } else {
         const form11url = `/main/do/form11?appId=${encryptedappid}&orgId=${encryptedorgid}`;
          window.open(form11url, "_blank");
        }
      }
    };

  // Handle Edit Certificate
  const handleEditCertificate = () => {
    setShowEditCertificateModal(true);
  };

  // Handle Edit Certificate Password Submit
  const handleEditCertificatePasswordSubmit = async () => {
    if (!editCertificatePassword.trim()) {
      showSnackbar("Please enter password", "warning");
      return;
    }

    try {
      // Verify password
      const orgId = localStorage.getItem("orgId");
      const passwordResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/verify-password`,
        {
          orgId: orgId,
          password: editCertificatePassword,
        },
      );

      if (!passwordResponse.data.success) {
        showSnackbar("Invalid password", "error");
        return;
      }

      // Password verified, navigate to edit certificate page
      const encryptedappid = encryptAppId(appId.toString());
      const encryptedorgid = encryptText(orgId.toString());
      const editCertificateUrl = `/main/do/edit-scope-certificate?appId=${encryptedappid}&orgId=${encryptedorgid}`;
      navigate(editCertificateUrl);
      // window.open(editCertificateUrl, '_blank')
    } catch (error) {
      console.error("Error verifying password:", error);
      showSnackbar("Invalid password or error occurred", "error");
    }
  };

  const handleSubmitDecision = () => {
    // Validate required fields
    if (!communicationSubject.trim()) {
      showSnackbar("Please enter Decision Letter Subject", "warning");
      return;
    }
    if (!communicationBody.trim()) {
      showSnackbar("Please enter Decision Letter Body", "warning");
      return;
    }

    setShowDecisionPasswordModal(true);
  };

  const handleDecisionPasswordSubmit = async () => {
    if (!decisionPassword.trim()) {
      showSnackbar("Please enter password", "warning");
      return;
    }

    try {
      // Verify password first
      const passwordResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/verify-password`,
        {
          orgId: localStorage.getItem("orgId") || "0",
          password: decisionPassword,
        },
      );

      if (!passwordResponse.data.success) {
        showSnackbar("Invalid password", "error");
        return;
      }

      // Save decision
      const response = await axios.post(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Savedecision`,
        {
          appId: appId,
          orgid: orgId,
          subject: communicationSubject.trim(),
          body: communicationBody.trim(),
        },
      );

      if (response.data && response.data.isstatus) {
        showSnackbar("Decision submitted successfully", "success");
        setShowDecisionPasswordModal(false);
        setDecisionPassword("");
        // Update hasDecisionData to show Send To Joint Director button
        if (communicationSubject.trim() && communicationBody.trim()) {
          setHasDecisionData(true);
        }
      } else {
        showSnackbar("Failed to submit decision", "error");
      }
    } catch (err) {
      console.error("Error submitting decision:", err);
      showSnackbar(err.response?.data?.message || "Invalid password", "error");
    }
  };

  const handleViewLetter = async () => {
    try {
      showSnackbar("Generating decision letter...", "info");

      // Check if application data is available
      if (!application) {
        showSnackbar(
          "Application data not loaded. Please wait and try again.",
          "warning",
        );
        return;
      }
      // Prepare letter data
      const letterData = {
        applicationNo: application.ApplicationNo || "N/A",
        letterDate: communicationLetterDate
          ? new Date(communicationLetterDate).toLocaleDateString("en-GB")
          : "",
        contactPerson: application.ContactPerson || "N/A",
        laboratoryName: application.LaboratoryName || "N/A",
        address: application.Address || "N/A",
        extAddress: application.ExtAddress || "N/A",
        mobile: application.ContactMobile || "N/A",
        email: application.ContactEmail || "N/A",
        subject: communicationSubject || "N/A",
        body: communicationBody || "N/A",
        advisoryList: [],
        doName: application.DoName || "N/A",
        doEmail: application.DoEmail || "N/A",
        showAdverseNote: false,
        showNewAddress: new Date() > new Date("2025-07-18"),
      };

      // Generate PDF
      await generateDecisionLetter(letterData);

      showSnackbar("Decision letter downloaded successfully", "success");
    } catch (err) {
      console.error("Error generating letter:", err);
      showSnackbar("Failed to generate decision letter", "error");
    }
  };

  const handleSendLetter = () => {
    setShowSendLetterModal(true);
  };

  const handleSendLetterSubmit = async () => {
    if (!sendLetterPassword.trim()) {
      showSnackbar("Please enter password", "warning");
      return;
    }

    try {
      // Verify password first
      const passwordResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/verify-password`,
        {
          orgId: localStorage.getItem("orgId") || "0",
          password: sendLetterPassword,
        },
      );

      if (!passwordResponse.data.success) {
        showSnackbar("Invalid password", "error");
        return;
      }

      // Send decision
      const response = await axios.post(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Senddecision`,
        {
          appId: appId,
          updatedby: localStorage.getItem("orgId") || "0",
          orgid: orgId,
        },
      );

      if (response.data && response.data.isstatus) {
        showSnackbar("Letter sent successfully", "success");
        setShowSendLetterModal(false);
        setSendLetterPassword("");
        setShowDecisionModal(false);
      } else {
        showSnackbar("Failed to send letter", "error");
      }
    } catch (err) {
      console.error("Error sending letter:", err);
      showSnackbar(err.response?.data?.message || "Invalid password", "error");
    }
  };

  const fetchReCertificateNo = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/ac-process/application/re-certificate-no/${appId}`
      );
      const val = response.data?.re_CertificateNo;
      if (val) {
        setReCertificateNo(val);
        setTxtCertificateNo(val);
      }
    } catch (err) {
      console.error("Error fetching re_CertificateNo:", err);
    }
  };

  // Load application data on mount
  useEffect(() => {
    if (appId) {
      initializePage();
      fetchPTPlan();
      checkTrailDataAvailability();
      fetchReCertificateNo();
    }
  }, [appId]);
  const fetchPTPlan = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Getptplan`,
        {
          params: { appid: appId },
        },
      );
      if (response.data && response.data.file) {
        setUploadedPtPlanFile(response.data.file);
        setPtPlanUploaded(true);
      } else {
        setUploadedPtPlanFile(null);
        setPtPlanUploaded(false);
      }
    } catch (err) {
      console.error("Error fetching PT Plan:", err);
      setUploadedPtPlanFile(null);
      setPtPlanUploaded(false);
    }
  };
  const handleViewPTPlan = async () => {
    if (!uploadedPtPlanFile) {
      showSnackbar("PT Plan file not found", "error");
      return;
    }
    try {
      setLoading(true);
      // Use s3Utils to handle file opening with signed URLs
      await s3Utils.handleFileViewWithS3(uploadedPtPlanFile, {
        showError: (msg) => setError(msg),
        showLoading: () => setLoading(true),
        hideLoading: () => setLoading(false),
        expiresIn: 172800, // 48 hours
      });
    } catch (err) {
      setError("Failed to open file");
      console.error("Error opening file:", err);
    } finally {
      setLoading(false);
    }
  };

  const initializePage = async () => {
    try {
      setLoading(true);
      setError(null);

      const [appDetailsResponse, labHeadResponse, doResponse] =
        await Promise.all([
          // Get application details (ApplicationNo, LaboratoryName, etc.)
          axios.get(
            `${process.env.REACT_APP_API_URL}/ac-process/application/details/${appId}`,
          ),
          // Get lab head/contact details (mode=27)
          axios.get(`${process.env.REACT_APP_API_URL}/do/allotment-details`, {
            params: {
              mode: 27,
              appId: appId,
            },
          }),
          // Get DO details (mode=31)
          axios.get(`${process.env.REACT_APP_API_URL}/do/allotment-details`, {
            params: {
              mode: 31,
              appId: appId,
            },
          }),
        ]);

      // Extract data from responses
      const appData = appDetailsResponse.data?.data || {};
      const labHeadData = labHeadResponse.data?.data?.[0] || {};
      const doData = doResponse.data?.data?.[0] || {};

      // Combine data
      const appDetails = {
        ApplicationNo: appData.ApplicationNo || "N/A",
        LaboratoryName: appData.LaboratoryName || "N/A",
        LabType: appData.LabType || "N/A",
        LabTypeId: appData.LabTypeId || null,
        newprefix: appData.newprefix || null,
        AssessmentTypeId: appData.AssessmentTypeId || null,
        AssessmentType: appData.AssessmentType || "N/A",
        ContactPerson: labHeadData.name || "N/A",
        Address: labHeadData.address || "N/A",
        ExtAddress:
          `${labHeadData.city || "N/A"} ${labHeadData.state || "N/A"} ${labHeadData.pincode || "N/A"}`.trim(),
        ContactMobile: labHeadData.mobile || "N/A",
        ContactEmail: labHeadData.email || "N/A",
        DoName: doData.name || "N/A",
        DoEmail: doData.email || "N/A",
        Stage: appData.Stage || "N/A",
        CommunicationLetterSent: appData.CommunicationLetterSent || 0,
      };

      setApplication(appDetails);
      setStage(appDetails.Stage);
      setShowHlDecision(appDetails?.CommunicationLetterSent === 0);
      setNewprefix(appDetails.newprefix)

      // Set certificate prefix based on LabTypeIdf
      if (appDetails.LabTypeId) {
        switch (appDetails.LabTypeId) {
          case 1:
            setTxtBoxCert("TC");
            break;
          case 2:
            setTxtBoxCert("CC");
            break;
          case 3:
            setTxtBoxCert("MC");
            break;
          case 4:
            setTxtBoxCert("PC");
            break;
          case 5:
            setTxtBoxCert("RC");
            break;
          default:
            setTxtBoxCert("");
        }
      }

      // Load data based on stage
      if (["6b", "6d", "6f", "11b"].includes(appDetails.Stage)) {
        await loadDateSelectionData(appId, appDetails.Stage);
        setShowChooseDate(true);
        setShowFinalStatus(false);
      } else if (
        [
          "6e",
          "7",
          "7a",
          "7b",
          "7c",
          "7d",
          "7e",
          "7f",
          "7g",
          "7h",
          "12",
          "12a",
          "12b",
          "12c",
          "14",
          "14a",
          "13e",
          "13",
          "13a",
          "13b",
          "13c",
          "13d",
          "11f",
          "11g",
          "11i",
        ].includes(appDetails.Stage)
      ) {
        // await loadFinalStatusData(appId, appDetails.Stage);
        await loadMOMFileData(appId);
        // Load AC Status data if LabTypeId available
        if (appDetails.LabTypeId) {
          await loadACStatusData(appId, appDetails.LabTypeId, orgId, appDetails.AssessmentTypeId);
        }
        // Load communication data for communication letter
        // await loadCommunicationData();
        // Load decision data to check if Send To Joint Director button should be shown
        await loadDecisionData();
        setShowChooseDate(false);
        setShowFinalStatus(true);
      }
    } catch (err) {
      console.error("Error initializing page:", err);
      setError("Failed to load application data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Load date selection data
  const loadDateSelectionData = async (appId, stage) => {
    try {
      const response = await acProcessService.getACProcessDetails(appId, orgId);
      setRepeaterData(response.data || []);

      if (response.data.length > 0) {
        if (stage === "6f") {
          setShowDateDiv(true);
        } else {
          setShowDateDiv(false);
        }
        setShowRepeaterDiv(true);
      } else {
        setShowDateDiv(true);
        setShowRepeaterDiv(false);
      }
    } catch (err) {
      console.error("Error loading date selection data:", err);
    }
  };

  // Load MOM File data
  const loadMOMFileData = async (appId) => {
    try {
      const response = await acProcessService.getMOMFileByAppId(appId);
      if (response.data && response.data.length > 0) {
        setMomFileData(response.data[0]);
      }
    } catch (err) {
      console.error("Error loading MOM file data:", err);
    }
  };

  // Load AC Status data
  const loadACStatusData = async (appId, labTypeId, orgId, assessmentTypeId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Getacstatus`,
        {
          params: {
            appid: appId,
            labtypeid: labTypeId,
            orgid: orgId,
          },
        },
      );

      if (response.data && response.data.isstatus) {
        const statusData = response.data;

        // Populate form fields with fetched data
        if (statusData.aC_Status) {
          setDdlStatus(statusData.aC_Status);
          // Trigger status change to show appropriate fields
          setTimeout(() => handleStatusChange(statusData.aC_Status), 100);
        }
        
        // Handle certificate generation based on assessment type and status
        if (assessmentTypeId === 1) {
          setShowLnkGenerateBtn(false);
          setShowDivCertno(false);
          setShowDivIssueDate(false);
        } else if (assessmentTypeId!==1 && statusData?.isStatusMarked === "0") {
          setRblCertNo("0");
          setShowLnkGenerateBtn(true);
          setShowDivCertno(false);
          setShowDivIssueDate(false);
        } else if (assessmentTypeId!==1 && statusData?.isStatusMarked === "1") {
          setRblCertNo("1");
          setShowLnkGenerateBtn(false);
          setShowDivCertno(true);
          setShowDivIssueDate(true);
        }

        if (statusData.amendmentChoice  ) {
          setAmendmentChoice(statusData.amendmentChoice);
        }

        if (statusData.remarks) {
          setTxtRemark(statusData.remarks);
        }

        if (statusData.toDate) {
          setTxtToDate(statusData.toDate);
        }

        if (statusData.amendmentDate) {
          setTxtAmendmentDate(statusData.amendmentDate);
        }

        if (statusData.cert_No) {
          setTxtCertificateNo(statusData.cert_No);
        }

        if (statusData.issue_Date) {
          setTxtIssueDate(convertDateToYYYYMMDD(statusData.issue_Date));
        }

        if (statusData.nextDueActivity) {
          setDdlNextDueActivity(statusData.nextDueActivity);
        }

        if (statusData.expectedDate) {
          // Convert DD/MM/YYYY to YYYY-MM-DD for date input
          const dateParts = statusData.expectedDate.split("/");
          if (dateParts.length === 3) {
            const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
            setTxtExpectedDate(formattedDate);
          } else {
            setTxtExpectedDate(statusData.expectedDate);
          }
        }

        if (statusData.iaC_Minutes) {
          setIacFileInState(statusData.iaC_Minutes);
          setUploadedIACFile(createFileObject(statusData.iaC_Minutes));
        }

        if (
          statusData.isCollingOffPeriod === "1" &&
          statusData.collingOffPeriodDate
        ) {
          setRbCoolingPeriod("1");
          setTxtCollingPeriod(statusData.collingOffPeriodDate);
        }

        console.log("AC Status data loaded successfully:", statusData);
      }
    } catch (err) {
      console.error("Error loading AC status data:", err);
      // Don't show error to user - it's optional data
    }
  };

  const createFileObject = (fileName) => {
    if (!fileName) return null;
    return {
      fileName: fileName,
      key: `live/${fileName}`,
      originalName: fileName,
    };
  };

  // Bind AC date options
  const bindDateOptions = async (acType) => {
    try {
      const response = await acProcessService.getACDatesByType(acType);
      setDateOptions(response.data || []);
      return response.data || [];
    } catch (err) {
      console.error("Error loading date options:", err);
      return [];
    }
  };

  // Bind AC date To options
  const bindDateToOptions = async (
    acType,
    dateFrom,
    dateOptionsArray = null,
  ) => {
    try {
      const optionsToUse = dateOptionsArray || dateOptions;
      const selectedDate = optionsToUse.find(
        (d) => d.Id && d.Id.toString() === dateFrom.toString(),
      );
      if (!selectedDate) {
        console.error("Selected date not found", dateFrom, optionsToUse);
        return [];
      }
      const response = await acProcessService.getACDateToByType(
        acType,
        selectedDate.Date,
      );
      setDateToOptions(response.data || []);
      return response.data || [];
    } catch (err) {
      console.error("Error loading date to options:", err);
      return [];
    }
  };

  // Handle AC Type change
  const handleAcTypeChange = (value) => {
    setDdlTypeOfAc(value);
    setDdlDate("0");
    setDdlDateTo("0");
    if (value !== "0") {
      bindDateOptions(value);
    }
  };

  // Handle Date From change
  const handleDateChange = (value) => {
    setDdlDate(value);
    setDdlDateTo("0");
    if (value !== "0" && ddlTypeOfAc !== "0") {
      const selectedDate = dateOptions.find((d) => d.Id.toString() === value);
      if (selectedDate) {
        bindDateToOptions(ddlTypeOfAc, value);
      }
    }
  };

  // Submit AC Date
  const handleSubmitDate = () => {
    // Validate
    if (ddlTypeOfAc === "0") {
      showSnackbar("Please Select Type of AC", "warning");
      return;
    }
    if (ddlDate === "0") {
      showSnackbar("Please Select From Date", "warning");
      return;
    }
    if (ddlDateTo === "0") {
      showSnackbar("Please Select To Date", "warning");
      return;
    }
    if (!txtRemarks.trim()) {
      showSnackbar("Please Enter Remarks", "warning");
      return;
    }

    checkDateRestriction();
  };

  const checkDateRestriction = async () => {
    try {
      const selectedDate = dateOptions.find((d) => d.Id.toString() === ddlDate);
      if (!selectedDate) return;

      const response = await acProcessService.checkDateTimeValidity(
        selectedDate.Date,
        3,
      );

      if (response.data && response.data.length > 0) {
        setShowPasswordModal(true);
      } else {
        showSnackbar("Agenda can not be punched now.", "warning");
      }
    } catch (err) {
      console.error("Error checking date restriction:", err);
      showSnackbar("Error validating date. Please try again.", "error");
    }
  };

  // Submit with password
  const handlePasswordSubmit = async () => {
    try {
      if (!txtPassword.trim()) {
        showSnackbar("Please enter password", "warning");
        return;
      }
      const orgId = localStorage.getItem("orgId");
      const passwordResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/verify-password`,
        {
          orgId: orgId,
          password: txtPassword,
        },
      );
      if (!passwordResponse.data.success) {
        showSnackbar("Invalid password", "error");
        return;
      }
      const payload = {
        appid: appId,
        acDate: ddlDate,
        acDateTo: ddlDateTo,
        acType: ddlTypeOfAc,
        doRemarks: txtRemarks,
        insertedBy: orgId,
        updatedBy: orgId,
        id: editingId,
      };
      const response = isUpdate
        ? await acProcessService.updateACProcess(payload)
        : await acProcessService.insertACProcess(payload);

      if (response.status === "success" || response.message) {
        await acProcessService.updateApplicationStage(appId, "6d");

        setShowPasswordModal(false);
        setTxtPassword("");
        showSnackbar("Date successfully alloted for AC Process.", "success");

        await loadDateSelectionData(appId, stage);

        setDdlTypeOfAc("0");
        setDdlDate("0");
        setDdlDateTo("0");
        setTxtRemarks("");
        setIsUpdate(false);
        setEditingId(null);
        setDateOptions([]);
        setDateToOptions([]);
      } else {
        showSnackbar("Failed to submit date", "error");
      }
    } catch (err) {
      console.error("Error submitting date:", err);
      showSnackbar("Invalid password or error occurred", "error");
    }
  };

  // Edit date from repeater
  const handleEditDate = async (item) => {
    setDdlTypeOfAc(item.AC_Type);
    setIsUpdate(true);
    setEditingId(item.Id);
    setShowDateDiv(true);

    // Load date options for the selected AC type
    const loadedDateOptions = await bindDateOptions(item.AC_Type);
    setDdlDate(item.dateid.toString());

    // Load date To options
    if (loadedDateOptions && loadedDateOptions.length > 0) {
      await bindDateToOptions(
        item.AC_Type,
        item.dateid.toString(),
        loadedDateOptions,
      );
      setDdlDateTo(item.dateidTo.toString());
    }

    setTxtRemarks(item.Do_Remarks);
  };

  // Cancel edit and reset form
  const handleCancelEdit = () => {
    setDdlTypeOfAc("0");
    setDdlDate("0");
    setDdlDateTo("0");
    setTxtRemarks("");
    setIsUpdate(false);
    setEditingId(null);
    setDateOptions([]);
    setDateToOptions([]);
    setShowDateDiv(false);
  };

  // Delete date from repeater
  const handleDeleteDate = async (id) => {
    if (!window.confirm("Do you want to Delete?")) return;

    try {
      const response = await acProcessService.deactivateACProcess(appId, id);
      if (response.status === "success" || response.message) {
        showSnackbar("Successfully Deleted the date", "success");
        await loadDateSelectionData(appId, stage);
      } else {
        showSnackbar("Failed to delete date", "error");
      }
    } catch (err) {
      console.error("Error deleting date:", err);
      showSnackbar("Error occurred while deleting", "error");
    }
  };

  // Generate certificate number
  const handleGenerateCertificate = async () => {
    try {
      if (!txtGeneratePassword.trim()) {
        showSnackbar("Please enter password", "warning");
        return;
      }
      const orgId = localStorage.getItem("orgId");
      const passwordResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/verify-password`,
        {
          orgId: orgId,
          password: txtGeneratePassword,
        },
      );

      if (!passwordResponse.data.success) {
        showSnackbar("Invalid password", "error");
        return;
      }
      const response = await axios.post(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Genratecertificatenumber?appid=${appId}`,
      );
      console.log("Certificate generation response:", response.data);
      if (response.data && response.data.isstatus) {
        setShowGenerateCertModal(false);
        setNewCertificateGenerateAPI(true);
        setTxtGeneratePassword("");
        showSnackbar("Certificate No generated successfully.", "success");
        await initializePage();
      } else {
        setNewCertificateGenerateAPI(false);
        showSnackbar(
          response.data?.message || "Failed to generate certificate",
          "error",
        );
      }
    } catch (err) {
      console.error("Error generating certificate:", err);
      showSnackbar("Invalid password or error occurred", "error");
    }
  };

  // Handle status change in Final Status dropdown
  const handleStatusChange = (value) => {
    setDdlStatus(value);

    // Reset visibility states
    setShowDivC(false);
    setShowDivToDate(false);
    setShowDivNextDueActivity(false);
    setShowDivExpectedDate(false);
    setShowDivAmendment(false);
    setShowDivRemarks(false);
    setShowDivShowcauseRemarks(false);
    setShowDivDiscipline(false);
    setShowDivReAssessType(false);
    setShowAdverseDecision(false);
    setShowDivRejctdRmrk(false);
    setShowLnkFinal(false);
    setShowLnkProcceedforDecision(false);

    // Show relevant fields based on status
    if (value === "Accreditation" || value === "Accreditation With Advisory") {
      setShowDivC(true);
      setShowDivToDate(false);
      setShowDivNextDueActivity(true);
      setShowDivExpectedDate(true);
      setShowDivAmendment(true);
      setShowDivRemarks(true);
      setShowLnkFinal(true);
    } else if (
      value === "Accredited with advisory including show cause notice"
    ) {
      setShowDivC(true);
      setShowDivToDate(false);
      setShowDivNextDueActivity(true);
      setShowDivExpectedDate(true);
      setShowDivAmendment(true);
      setShowDivShowcauseRemarks(true);
      setShowLnkFinal(true);
    } else if (value === "Show Cause") {
      setShowDivC(true);
      setShowDivShowcauseRemarks(true);
      setShowLnkFinal(true);
    } else if (
      value === "Denial" ||
      value === "Force Withdrwal" ||
      value === "Close" ||
      value === "Debar from Reapply Certification Preparation"
    ) {
      //setShowDivC(true);
      //setShowAdverseDecision(true);
      //setShowDivRemarks(true);
      //setShowLnkFinal(true);
      //setShowDivC(false);
      setShowDivToDate(false);
      setShowDivNextDueActivity(false);
      setShowDivExpectedDate(false);
      setShowDivAmendment(false);
      setShowDivRemarks(true);
      setShowDivShowcauseRemarks(false);
      setShowDivDiscipline(false);
      setShowDivReAssessType(false);
      setShowAdverseDecision(false);
      setShowDivRejctdRmrk(false);
      setShowLnkFinal(false);
      setShowLnkProcceedforDecision(false);
    } else if (value === "Mark for Re Assessment") {
      setShowDivC(true);
      //setShowDivReAssessType(true);
      setShowDivRemarks(true);
      setShowLnkFinal(true);
    } else if (value === "Abeyance" || value === "Suspension") {
      // setShowDivC(true);
      // setShowDivRemarks(true);
      // setShowLnkFinal(true);
      setShowDivToDate(false);
      setShowDivNextDueActivity(false);
      setShowDivExpectedDate(false);
      setShowDivAmendment(false);
      setShowDivRemarks(true);
      setShowDivShowcauseRemarks(false);
      setShowDivDiscipline(false);
      setShowDivReAssessType(false);
      setShowAdverseDecision(false);
      setShowDivRejctdRmrk(false);
      setShowLnkFinal(false);
    } else if (value === "0") {
      setShowLnkFinal(false);
    } else {
      setShowDivRemarks(true);
      setShowLnkFinal(true);
    }
  };

  // Handle certificate number generation choice
  const handleCertNoChange = (value) => {
    setRblCertNo(value);
    if (value === "0") {
      setShowLnkGenerateBtn(true);
      setShowDivCertno(false);
      setShowDivIssueDate(false);
    } else {
      setShowLnkGenerateBtn(false);
      setShowDivCertno(true);
      setShowDivIssueDate(true);
    }
  };

  // Calculate expected date based on To Date and Next Due Activity
  const calculateExpectedDate = () => {
    if (!txtToDate || ddlNextDueActivity === "0") return;

    try {
      const toDate = new Date(txtToDate);
      let expectedDate = new Date(toDate);

      if (ddlNextDueActivity === "Desktop Application") {
        expectedDate.setFullYear(toDate.getFullYear() + 1);
        expectedDate.setMonth(toDate.getMonth() - 3); // 9 months from issue
      } else if (ddlNextDueActivity === "Surveillance Application") {
        expectedDate.setFullYear(toDate.getFullYear() + 1);
        expectedDate.setMonth(toDate.getMonth() - 3); // 9 months from issue
      } else if (ddlNextDueActivity === "Renewal Application") {
        expectedDate.setFullYear(toDate.getFullYear() - 1);
        expectedDate.setMonth(toDate.getMonth() + 10); // 10 months before expiry
      }

      // Format to YYYY-MM-DD
      const formattedDate = expectedDate.toISOString().split("T")[0];
      setTxtExpectedDate(formattedDate);
    } catch (err) {
      console.error("Error calculating expected date:", err);
    }
  };

  // Handle cooling period change
  const handleCoolingPeriodChange = (value) => {
    setRbCoolingPeriod(value);
  };

  // Handle file upload from FileUploadComponent
  const handleFileUploadChange = (fieldName, fileData) => {
    if (fieldName === "iacFile") {
      if (fileData) {
        setUploadedIACFile(fileData);
        showSnackbar("IAC file uploaded successfully", "success");
      } else {
        setUploadedIACFile(null);
      }
    }
  };

  // Check date validity - validates if date is at least N days in the future
  const checkDateValidity = async (dateToCheck, daysRequired = 3) => {
    try {
      // Convert date from YYYY-MM-DD to dd/MM/yyyy format for API
      const dateObj = new Date(dateToCheck);
      const day = String(dateObj.getDate()).padStart(2, "0");
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const year = dateObj.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;

      const response = await acProcessService.checkDateTimeValidity(
        formattedDate,
        daysRequired,
      );

      if (
        response.data &&
        response.data.length > 0 &&
        response.data[0].chk === 1
      ) {
        return false; // Date restriction violated
      }
      return true; // Date is valid
    } catch (err) {
      console.error("Error checking date validity:", err);
      return true; // Allow submission if validation fails
    }
  };

  // Convert date from YYYY-MM-DD to DD/MM/YYYY
  const convertDateToDDMMYYYY = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (err) {
      console.error("Error converting date:", err);
      return dateString;
    }
  };

  const convertDateToYYYYMMDD = (dateString) => {
    if (!dateString) return "";
    try {
      // Check if already in YYYY-MM-DD format
      if (dateString.includes("-")) return dateString;
      // Convert from DD/MM/YYYY to YYYY-MM-DD
      const dateParts = dateString.split("/");
      if (dateParts.length === 3) {
        return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
      }
      return dateString;
    } catch (err) {
      console.error("Error converting date:", err);
      return dateString;
    }
  };

  // Handle Issue Date change with validation
  const handleIssueDateChange = async (e) => {
    const newDate = e.target.value;
    setTxtIssueDate(newDate);

    // if (newDate) {
    //   const isDateValid = await checkDateValidity(newDate, 3);
    //   if (!isDateValid) {
    //     showSnackbar("Agenda can not be punched now.", "warning");
    //   }
    // }
  };

  // Handle Amendment Date change with validation
  const handleAmendmentDateChange = (e) => {
    const newDate = e.target.value;
    setTxtAmendmentDate(newDate);

    if (newDate && txtIssueDate && txtToDate) {
      const amendmentDate = new Date(newDate);
      const issueDate = new Date(txtIssueDate);
      const validityDate = new Date(txtToDate);

      if (amendmentDate < issueDate || amendmentDate > validityDate) {
        showSnackbar(
          "Amendment date must be between Issue Date and Validity Till date.",
          "warning",
        );
      }
    }
  };

  // Handle final status submission
  const handleSubmitStatus = async () => {
    try {
      // Validation
      if (ddlStatus === "0") {
        showSnackbar("Please select final status", "warning");
        return;
      }
      // Additional validations based on status
      if (
        (ddlStatus === "Accreditation" ||
          ddlStatus === "Accreditation With Advisory" ||
          ddlStatus === "Accredited with advisory including show cause notice") &&
        (ddlNextDueActivity === "0" || !txtExpectedDate)
      ) {
        showSnackbar("Please fill all required fields", "warning");
        return;
      }
      // if (showAdverseDecision && rbCoolingPeriod === "1" && !txtCollingPeriod) {
      //   showSnackbar("Please enter cooling off period date", "warning");
      //   return;
      // }

      // Validate Show Cause remarks
      if (
        (ddlStatus === "Show Cause" ||
          ddlStatus ===
            "Accredited with advisory including show cause notice") &&
        !txtShowcauseRemarks.trim()
      ) {
        showSnackbar("Please enter Show Cause remarks", "warning");
        return;
      }

      // Validate Mark for Re Assessment fields
      // if (ddlStatus === "Mark for Re Assessment" && !rbAssesstype) {
      //   showSnackbar("Please select Assessment Type", "warning");
      //   return;
      // }

      if (application?.AssessmentTypeId !== 1 && rblCertNo === "0") {
        if (!newCertificateGenerateAPI) {
          showSnackbar("Please generate new certificate number", "warning");
          return;
        }
      }

      if(application?.AssessmentTypeId !== 1 && rblCertNo === "1"){
        if (!txtCertificateNo.trim()) {
          showSnackbar("Please enter certificate number", "warning");
          return;
        }
        if (!txtIssueDate) {
          showSnackbar("Please select issue date", "warning");
          return;
        }
        if (!amendmentChoice) {
          showSnackbar("Please select amendment choice", "warning");
          return;
        }
      }

      // Validate regular remarks for statuses that require it
      if (
        (ddlStatus === "Accreditation" ||
          ddlStatus === "Accreditation With Advisory" ||
          ddlStatus === "Denial" ||
          ddlStatus === "Force Withdrwal" ||
          ddlStatus === "Close" ||
          ddlStatus === "Debar from Reapply Certification Preparation" ||
          ddlStatus === "Mark for Re Assessment" ||
          ddlStatus === "Abeyance" ||
          ddlStatus === "Suspension") &&
        !txtRemark.trim()
      ) {
        showSnackbar("Please enter remarks", "warning");
        return;
      }

      //Date validation - check if issue date is valid (at least 3 days in future)
      // if (txtIssueDate) {
      //   const isDateValid = await checkDateValidity(txtIssueDate, 3);
      //   if (!isDateValid) {
      //     showSnackbar("Agenda can not be punched now.", "warning");
      //     return;
      //   }
      // }

      // Validate amendment date is between issue date and validity date
      // if (txtAmendmentDate && txtIssueDate && txtToDate) {
      //   const amendmentDate = new Date(txtAmendmentDate);
      //   const issueDate = new Date(txtIssueDate);
      //   const validityDate = new Date(txtToDate);

      //   if (amendmentDate < issueDate || amendmentDate > validityDate) {
      //     showSnackbar('Amendment date must be between Issue Date and Validity Till date.', 'error');
      //     return;
      //   }
      // }

      setLoading(true);
      // Handle file upload - use uploaded file from FileUploadComponent
      let iacFilePath = iacFileInState || "";
      if (uploadedIACFile && uploadedIACFile.fileName) {
        iacFilePath = uploadedIACFile.fileName;
      }
      // Prepare data for mark status API
      const statusData = {
        appId: appId.toString(),
        orgid: orgIdFromUrl,
        status: ddlStatus,
        remarks: txtRemark || "",
        showCauseRemarks: txtShowcauseRemarks || "",
        toDate: txtToDate,
        nextDueActivity: ddlNextDueActivity === "0" ? "" : ddlNextDueActivity,
        expectedDate: txtExpectedDate,
        amendmentDate: txtAmendmentDate,
       // certificateNo: (application?.AssessmentTypeId !== 1 && rblCertNo === "1")? `${newprefix}-${txtCertificateNo}` : '',
        OldcertificateNo: (application?.AssessmentTypeId !== 1 && rblCertNo === "1") ? (txtCertificateNo || "") : "",
        issueDate: txtIssueDate ? convertDateToDDMMYYYY(txtIssueDate) : "",
        coolingPeriod: rbCoolingPeriod || "0",
        coolingPeriodDate: txtCollingPeriod,
        generateNewCertNo: rblCertNo || "0",
        assessmentType: rbAssesstype || "",
        markForReAssessment: ddlStatus === "Mark for Re Assessment" ? "1" : "0",
        filePath: iacFilePath,
        amendmentChoice: amendmentChoice || "No",
        isStatusMarked: rblCertNo,
      };
      // Direct API call to Mark Status endpoint
      const response = await axios.post(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Markstatus`,
        statusData,
        {
          headers: { "Content-Type": "application/json" },
        },
      );
      if (response.data && response.data.isstatus) {
        showSnackbar(
          response.data.message || "Final status submitted successfully",
          "success",
        );
        await initializePage();
      } else {
        showSnackbar(
          response.data?.message || "Failed to submit final status",
          "error",
        );
      }
    } catch (err) {
      console.error("Error submitting final status:", err);
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Failed to submit final status";
      showSnackbar(errorMessage, "error");
    } finally {
      setLoading(false);
    }
  };

  // Fetch scope data from API
  const fetchScopeData = async () => {
    try {
      setLoadingScopeData(true);

      // Fetch certificate data (test records)
      const certificatemainDataResponse = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/GetMaincertificatedata?appid=${appId}&labtypeid=${application?.LabTypeId}`,
      );
      // Fetch certificate data (test records)
      const certificateResponse = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Getcertificatedata?appid=${appId}&token=nablgvfdcrtyfbskgirwsoh`,
      );

      // Fetch location data (certificate info)
      const locationResponse = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/CertificateLocation?appid=${appId}&check=nablgvfdcrtyfbskgirwsoh`,
      );

      const certificateData = certificateResponse.data?.certificate || [];
      const locationData = locationResponse.data?.certlocation?.[0] || {};

      // Transform API data to match ScopeGenerator format
      const transformedRecords = certificateData.map((record) => ({
        discipline: record.disciplineName || "",
        productMaterial: record.productMaterial || "",
        specificTest: record.specifictest || "",
        scopeYear: record.scopeyear || "",
        unit: record.unit || "",
        measr: record.measr || "",
        heading1: record.heading1 || "",
        heading2: record.heading2 || "",
        heading3: record.heading3 || "",
        heading4: record.heading4 || "",
        heading5: record.heading5 || "",
        heading6: record.heading6 || "",
        groupName: record.groupName || "",
        testcode: record.testcode || "",
      }));

      // Prepare scope data
      const scopeDataObj = {
        labName:
          locationData.labName ||
          application?.LabName ||
          application?.Organization_Name ||
          "",
        location: locationData.location || application?.Address || "",
        address: certificatemainDataResponse?.data?.address || "",
        standard: locationData.standard || "-",
        certificateNumber:
          locationData.cert_No || (txtBoxCert || "") + (txtCertificateNo || ""),
        issueDate: locationData.issue_Date
          ? new Date(locationData.issue_Date).toLocaleDateString("en-GB")
          : "N/A",
        validUntil: locationData.validuntill
          ? new Date(locationData.validuntill).toLocaleDateString("en-GB")
          : "N/A",
        amendmentDate: locationData.amendmentDate
          ? dayjs(locationData.amendmentDate, "MMM DD YYYY h:mma").format(
              "DD/MM/YYYY",
            )
          : "N/A",
        headerChange: locationData.isNew === "1",
        legalEntity:
          application?.LabName || application?.Organization_Name || "",
        additionaldata: certificatemainDataResponse?.data.additionaldata
          ? certificatemainDataResponse?.data.additionaldata
          : "",
        applicationNo: certificatemainDataResponse?.data.applicationNo
          ? certificatemainDataResponse?.data.applicationNo
          : "",
        field:
          application?.LabTypeId === 1
            ? "TESTING"
            : application?.LabTypeId === 2
              ? "CALIBRATION"
              : application?.LabTypeId === 3
                ? "MEDICAL"
                : application?.LabTypeId === 4
                  ? "PTP"
                  : application?.LabTypeId === 5
                    ? "RMP"
                    : "",
        records: transformedRecords,
        // Additional fields from API
        labType: locationData.labType || application?.LabType,
        validity: locationData.validity || "",
        permanent: locationData.permanent === "1",
        mobile: locationData.mobile === "1",
        site: locationData.site === "1",
        potc: locationData.potc === "1",
        appId: appId,
        orgId: orgIdFromUrl,
      };
      setCertificateMainData(certificatemainDataResponse.data || {});
      setScopeData(scopeDataObj);
      setLoadingScopeData(false);
      return scopeDataObj;
    } catch (error) {
      console.error("Error fetching scope data:", error);
      setLoadingScopeData(false);
      showSnackbar("Failed to fetch scope data from API", "warning");
      return null;
    }
  };

  // Fetch SCF data from API
  const fetchSCFData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/GetSCFscope?appid=${appId}&token=nablgvfdcrtyfbskgirwsoh`,
      );

      const data = response.data;

      if (data.isstatus && data.scope && data.scope.length > 0) {
        setScfData(data.scope);
        return data.scope;
      } else {
        setScfData([]);
        return [];
      }
    } catch (error) {
      console.error("Error fetching SCF data:", error);
      setScfData([]);
      showSnackbar("Failed to fetch SCF data", "warning");
      return [];
    }
  };

  // Handle opening certificate dialog with scope data
  const handleOpenCertificateDialog = async (action) => {
    window.open(
      `/main/viewCertificate?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}&action=${encryptText(action)}`,
      "_blank",
    );
    // setShowCertificateDialog(true);
    // // Fetch scope data when dialog opens if not already fetched
    // if (!scopeData && appId) {
    //   await fetchScopeData();
    // }
    // // Fetch SCF data
    // if (!scfData && appId) {
    //   await fetchSCFData();
    // }
  };

  const handleFileOpen = async (fileUrl) => {
    if (!fileUrl) {
      setError("No file available to view");
      return;
    }
    try {
      setLoading(true);
      // Use s3Utils to handle file opening with signed URLs
      await s3Utils.handleFileViewWithS3(fileUrl, {
        showError: (msg) => setError(msg),
        showLoading: () => setLoading(true),
        hideLoading: () => setLoading(false),
        expiresIn: 172800, // 48 hours
      });
    } catch (err) {
      setError("Failed to open file");
      console.error("Error opening file:", err);
    } finally {
      setLoading(false);
    }
  };

const saveCertificateUrl = async (orgIds) => {
  await Promise.all(
    orgIds.map(async (orgId) => {
      try {
        const latestappid = await axios.get(
          `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/GetLatestAppid?orgid=${orgId}&token=nablgvfdcrtyfbskgirwsoh`
        );

        const path = `${process.env.REACT_APP_PAGE_URL}/viewCertificate?appId=${encryptText(latestappid.data.appid)}&orgId=${encryptText(orgId)}&action=${encryptText("download")}`;

        await axios.post(
          `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Savecertificateurl`,
          {
            appid: latestappid.data.appid,
            URl: path,
            updatedby: localStorage.getItem("orgId"),
            type: "MainURL",
          }
        );

        console.log(`Done for OrgId: ${orgId}`);
      } catch (error) {
        console.error(`Error for OrgId: ${orgId}`, error);
      }
    })
  );
};

  // Render loading state
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Render error state
  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error}</Alert>
        <Button
          onClick={() =>
            navigate(
              `/main/do/applications/appdashboard?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}`,
            )
          }
          startIcon={<ArrowBack />}
          sx={{ mt: 2 }}
        >
          Go Back
        </Button>
      </Box>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ p: 2, maxWidth: 1400, mx: "auto" }}>
        {/* Modern Header with Gradient Background */}
        <Paper
          elevation={0}
          sx={{
            background: "linear-gradient(135deg, #00024c 0%, #1a2b6b 100%)",
            color: "white",
            borderRadius: 0,
            mb: 3,
          }}
        >
          <Box sx={{ px: 3, py: 3 }}>
            {/* Header Content */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Avatar
                  sx={{
                    bgcolor: "rgba(255,255,255,0.2)",
                    mr: 2,
                    width: 56,
                    height: 56,
                  }}
                >
                  <Assignment sx={{ fontSize: 28 }} />
                </Avatar>
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                    {application ? application.LaboratoryName : "AC Process"}
                  </Typography>
                  <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
                    Manage Assessment Committee dates and process
                  </Typography>
                  {application && (
                    <Box
                      sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}
                    >
                      <Chip
                        label={`Application No: ${application.ApplicationNo}`}
                        variant="outlined"
                        size="small"
                        sx={{
                          color: "white",
                          borderColor: "rgba(255,255,255,0.7)",
                        }}
                      />
                      <Chip
                        label={`Lab Type: ${application.LabType}`}
                        variant="outlined"
                        size="small"
                        sx={{
                          color: "white",
                          borderColor: "rgba(255,255,255,0.7)",
                        }}
                      />
                      <Chip
                        label={`Assessment: ${application.AssessmentType}`}
                        variant="outlined"
                        size="small"
                        sx={{
                          color: "white",
                          borderColor: "rgba(255,255,255,0.7)",
                        }}
                      />
                    </Box>
                  )}
                </Box>
              </Box>
              <Button
                startIcon={<ArrowBack />}
                onClick={() =>
                  navigate( `/main/do/applications/appdashboard?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}`)
                }
                sx={{
                  color: "white",
                  bgcolor: "rgba(255,255,255,0.1)",
                  borderColor: "rgba(255,255,255,0.3)",
                  "&:hover": {
                    borderColor: "white",
                    bgcolor: "rgba(255,255,255,0.2)",
                  },
                }}
                variant="outlined"
              >
                Back
              </Button>
            </Box>
          </Box>
        </Paper>

        {/* Choose Date Section */}
        {showChooseDate && (
          <Fade in={showChooseDate} timeout={1200}>
            <Card
              elevation={8}
              sx={{
                mb: 2,
                mt: 2,
                borderRadius: 3,
                overflow: "hidden",
                border: "1px solid rgba(102, 126, 234, 0.2)",
              }}
            >
              <Box
                sx={{
                  p: 3,
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    background: "rgba(255,255,255,0.2)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <CalendarToday sx={{ fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography variant="h5" sx={{ fontWeight: 700 }}>
                    Choose AC Date
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    Select assessment committee dates and details
                  </Typography>
                </Box>
              </Box>
              <CardContent sx={{ p: 4 }}>
                {showDateDiv && (
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <FormControl
                        fullWidth
                        required
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            transition: "all 0.3s ease",
                            "&:hover": {
                              boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.1)",
                            },
                            "&.Mui-focused": {
                              boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.2)",
                            },
                          },
                        }}
                      >
                        <InputLabel>Type of AC</InputLabel>
                        <Select
                          value={ddlTypeOfAc}
                          onChange={(e) => handleAcTypeChange(e.target.value)}
                          label="Type of AC"
                        >
                          {acTypeOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl
                        fullWidth
                        required
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            transition: "all 0.3s ease",
                            "&:hover": {
                              boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.1)",
                            },
                            "&.Mui-focused": {
                              boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.2)",
                            },
                          },
                        }}
                      >
                        <InputLabel>Select From Date</InputLabel>
                        <Select
                          value={ddlDate}
                          onChange={(e) => handleDateChange(e.target.value)}
                          label="Select From Date"
                          disabled={ddlTypeOfAc === "0"}
                        >
                          <MenuItem value="0">-- Select Date --</MenuItem>
                          {dateOptions.map((option) => (
                            <MenuItem key={option.Id} value={option.Id}>
                              {option.Date}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl
                        fullWidth
                        required
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            transition: "all 0.3s ease",
                            "&:hover": {
                              boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.1)",
                            },
                            "&.Mui-focused": {
                              boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.2)",
                            },
                          },
                        }}
                      >
                        <InputLabel>Select To Date</InputLabel>
                        <Select
                          value={ddlDateTo}
                          onChange={(e) => setDdlDateTo(e.target.value)}
                          label="Select To Date"
                          disabled={ddlDate === "0"}
                        >
                          <MenuItem value="0">-- Select Date --</MenuItem>
                          {dateToOptions.map((option) => (
                            <MenuItem key={option.Id} value={option.Id}>
                              {option.DateTo || option.Date || "N/A"}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        multiline
                        label="Remarks"
                        value={txtRemarks}
                        onChange={(e) => setTxtRemarks(e.target.value)}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            transition: "all 0.3s ease",
                            "&:hover": {
                              boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.1)",
                            },
                            "&.Mui-focused": {
                              boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.2)",
                            },
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sx={{ textAlign: "center", mt: 2 }}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          onClick={handleSubmitDate}
                          size="large"
                          sx={{
                            px: 5,
                            py: 1.5,
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "1rem",
                            background:
                              "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              background:
                                "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                              boxShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
                              transform: "translateY(-2px)",
                            },
                            "&:active": {
                              transform: "translateY(0)",
                            },
                          }}
                        >
                          {isUpdate ? "Update" : "Submit"}
                        </Button>
                        {isUpdate && (
                          <Button
                            variant="outlined"
                            onClick={handleCancelEdit}
                            size="large"
                            sx={{
                              px: 5,
                              py: 1.5,
                              borderRadius: 2,
                              textTransform: "none",
                              fontWeight: 600,
                              fontSize: "1rem",
                              borderColor: "#667eea",
                              color: "#667eea",
                              transition: "all 0.3s ease",
                              "&:hover": {
                                borderColor: "#764ba2",
                                color: "#764ba2",
                                background: "rgba(102, 126, 234, 0.05)",
                                transform: "translateY(-2px)",
                              },
                              "&:active": {
                                transform: "translateY(0)",
                              },
                            }}
                          >
                            Cancel
                          </Button>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                )}

                {/* Repeater Table */}
                {showRepeaterDiv && repeaterData.length > 0 && (
                  <Box>
                    <Box
                      sx={{
                        mb: 2,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: 600, color: "#2c3e50" }}
                      >
                        Scheduled AC Dates
                      </Typography>
                      <Chip
                        label={`${repeaterData.length} Record${repeaterData.length > 1 ? "s" : ""}`}
                        size="small"
                        sx={{
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          color: "white",
                          fontWeight: 600,
                        }}
                      />
                    </Box>
                    <TableContainer
                      sx={{
                        borderRadius: 2,
                        border: "1px solid rgba(0,0,0,0.08)",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Table>
                        <TableHead>
                          <TableRow
                            sx={{
                              background:
                                "linear-gradient(135deg, #667eea15 0%, #764ba215 100%)",
                            }}
                          >
                            <TableCell
                              sx={{ fontWeight: 700, color: "#2c3e50" }}
                            >
                              Sr. No.
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: 700, color: "#2c3e50" }}
                            >
                              From Date
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: 700, color: "#2c3e50" }}
                            >
                              To Date
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: 700, color: "#2c3e50" }}
                            >
                              AC Type
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: 700, color: "#2c3e50" }}
                            >
                              Remarks
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: 700, color: "#2c3e50" }}
                            >
                              Action
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {repeaterData.map((row, index) => (
                            <TableRow
                              key={row.Id}
                              sx={{
                                transition: "all 0.2s ease",
                                "&:hover": {
                                  background: "rgba(102, 126, 234, 0.05)",
                                  transform: "scale(1.005)",
                                },
                              }}
                            >
                              <TableCell sx={{ fontWeight: 500 }}>
                                {index + 1}
                              </TableCell>
                              <TableCell sx={{ fontWeight: 500 }}>
                                {row.Date}
                              </TableCell>
                              <TableCell sx={{ fontWeight: 500 }}>
                                {row.DateTo}
                              </TableCell>
                              <TableCell>
                                <Chip
                                  label={row.AC_Type}
                                  size="small"
                                  sx={{
                                    background:
                                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                    color: "white",
                                    fontWeight: 600,
                                  }}
                                />
                              </TableCell>
                              <TableCell sx={{ maxWidth: 300 }}>
                                {row.Do_Remarks}
                              </TableCell>
                              <TableCell>
                                <Box sx={{ display: "flex", gap: 1 }}>
                                  {row.Visbtn === "1" && (
                                    <IconButton
                                      size="small"
                                      onClick={() => handleEditDate(row)}
                                      sx={{
                                        color: "#667eea",
                                        transition: "all 0.2s ease",
                                        "&:hover": {
                                          background:
                                            "rgba(102, 126, 234, 0.1)",
                                          transform: "scale(1.1)",
                                        },
                                      }}
                                    >
                                      <Edit fontSize="small" />
                                    </IconButton>
                                  )}
                                  {row.Visbtn === "1" && (
                                    <IconButton
                                      size="small"
                                      onClick={() => handleDeleteDate(row.Id)}
                                      sx={{
                                        color: "#f44336",
                                        transition: "all 0.2s ease",
                                        "&:hover": {
                                          background: "rgba(244, 67, 54, 0.1)",
                                          transform: "scale(1.1)",
                                        },
                                      }}
                                    >
                                      <Delete fontSize="small" />
                                    </IconButton>
                                  )}
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Fade>
        )}

        {/* Final Status Section */}
        {showFinalStatus && (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Paper
                sx={{
                  p: 3,
                  mt: 1,
                  borderRadius: 3,
                  background: "rgba(102, 126, 234, 0.05)",
                }}
              >
                <Box sx={{ alignItems: "center", mb: 2 }}>
                  <Typography variant="h5">Final Status</Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 1,
                      mt: 1,
                    }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={handleForm11}
                    >
                      Form 11
                    </Button>
                    {ptPlanUploaded && (
                      <Button
                        variant="contained"
                        size="small"
                        color="info"
                        onClick={handleViewPTPlan}
                      >
                        View PT Plan
                      </Button>
                    )}
                    <Button
                      variant="contained"
                      size="small"
                      color="info"
                      startIcon={<Visibility />}
                      onClick={handleViewScopeReport}
                    >
                      Form 72
                    </Button>
                    {application?.CommunicationLetterSent === 1 && (
                      <Button
                        variant="contained"
                        size="small"
                        color="info"
                        startIcon={<Visibility />}
                        onClick={handleViewCommunicationLetter}
                      >
                        View Communication Letter
                      </Button>
                    )}
                    {hasDecisionData && (
                      <Button
                        variant="contained"
                        size="small"
                        color="success"
                        startIcon={<Visibility />}
                        onClick={handleViewLetter}
                      >
                        View Decision Letter
                      </Button>
                    )}
                    {(stage === "7" ||
                      stage === "7c" ||
                      stage === "7d" ||
                      stage === "7e" ||
                      stage === "7f" ||
                      stage === "7g" ||
                      stage === "7b" ||
                      stage === "7a" ||
                      stage === "12" ||
                      stage === "12a" ||
                      stage === "12b") && (
                      <Button
                        variant="contained"
                        size="small"
                        color="success"
                        onClick={() => {
                          const url = `/main/do/advisory?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}&assessmentId=${encryptText(assessmentId)}&labTypeId=${application?.LabTypeId || "3"}`;
                          // navigate(url);
                          window.open(url, "_blank");
                        }}
                      >
                        Advisory
                      </Button>
                    )}
                    <Button
                      variant="outlined"
                      size="small"
                      color="primary"
                      startIcon={<Download />}
                      onClick={() => handleOpenCertificateDialog("download")}
                      disabled={loadingScopeData}
                    >
                      {loadingScopeData ? "Loading..." : "Download Certificate"}
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 1,
                      mt: 1,
                    }}
                  >
                    {(stage === "7" ||
                      stage === "7e" ||
                      stage === "7g" ||
                      stage === "12" ||
                      stage === "12a" ||
                      stage === "12b") && (
                      <>
                        <Button
                          variant="contained"
                          size="small"
                          color="secondary"
                          onClick={handleEditCertificate}
                        >
                          Edit Certificate
                        </Button>
                      </>
                    )}
                      {(stage === "7" ||
                      stage === "7e" ||
                      stage === "7g" ||
                      stage === "12" ||
                      stage === "12a" ||
                      stage === "12b") && (
                      <>
                        <Button
                          variant="outlined"
                          size="small"
                          color="primary"
                          startIcon={<Download />}
                          onClick={() =>
                            handleOpenCertificateDialog("regenerate")
                          }
                          disabled={loadingScopeData}
                        >
                          {loadingScopeData
                            ? "Loading..."
                            : "Re-generate Certificate"}
                        </Button>
                      </>
                    )}
                    {hasTrailData && (
                      <Button
                        variant="outlined"
                        size="small"
                        color="secondary"
                        startIcon={<Visibility />}
                        onClick={handleOpenCertificateTrail}
                        disabled={loadingTrailData}
                      >
                        {loadingTrailData
                          ? "Loading..."
                          : "View Certificate Trail"}
                      </Button>
                    )}
                  </Box>
                </Box>

                {/* MOM File Data Display */}
                {momFileData && (
                  <Box
                    sx={{
                      mt: 2,
                      mb: 3,
                      p: 2,
                      borderRadius: 2,
                      background: "white",
                      boxShadow: 1,
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, mb: 2, color: "#667eea" }}
                    >
                      MOM File Details
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ fontWeight: 600 }}
                          >
                            MOM Word File:
                          </Typography>
                          <Button
                            size="small"
                            startIcon={<Visibility />}
                            onClick={() =>
                              momFileData.MOMfile
                                ? handleFileOpen(momFileData.MOMfile)
                                : showSnackbar(
                                    "No Word file available",
                                    "error",
                                  )
                            }
                            variant="outlined"
                            sx={{ textTransform: "none" }}
                          >
                            View
                          </Button>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ fontWeight: 600 }}
                          >
                            MOM Pdf File:
                          </Typography>
                          <Button
                            size="small"
                            startIcon={<Visibility />}
                            onClick={() =>
                              momFileData.MOM_Format
                                ? handleFileOpen(momFileData.MOM_Format)
                                : showSnackbar("No PDF file available", "error")
                            }
                            variant="outlined"
                            sx={{ textTransform: "none" }}
                          >
                            View
                          </Button>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ fontWeight: 600 }}
                          >
                            From Date:
                          </Typography>
                          <Typography variant="body1">
                            {momFileData.FromDate}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ fontWeight: 600 }}
                          >
                            To Date:
                          </Typography>
                          <Typography variant="body1">
                            {momFileData.ToDate}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                )}

                <Grid container spacing={2} sx={{ mt: 2 }}>
                  {/* Status Dropdown */}
                  <Grid item xs={12}>
                    <FormControl fullWidth required>
                      <InputLabel>Final Status</InputLabel>
                      <Select
                        value={ddlStatus}
                        onChange={(e) => handleStatusChange(e.target.value)}
                        label="Final Status"
                      >
                        <MenuItem value="0">-----Select---</MenuItem>
                        <MenuItem value="Accreditation">Accredited</MenuItem>
                        <MenuItem value="Accreditation With Advisory">
                          Accredited With Advisory
                        </MenuItem>
                        <MenuItem value="Accredited with advisory including show cause notice">
                          Accredited with advisory including Showcause/Subject
                          to
                        </MenuItem>
                        <MenuItem value="Show Cause">
                          Showcause/Subject to
                        </MenuItem>
                        <MenuItem value="Close">Closed</MenuItem>
                        <MenuItem value="Denial">
                          Denial of Accreditation
                        </MenuItem>
                        <MenuItem value="Abeyance">Abeyance</MenuItem>
                        <MenuItem value="Suspension">Suspension</MenuItem>
                        <MenuItem value="Force Withdrwal">
                          Withdrawal of Accreditation
                        </MenuItem>
                        <MenuItem value="Debar from Reapply Certification Preparation">
                          Debar from Reapply
                        </MenuItem>
                        <MenuItem value="Mark for Re Assessment">
                          On-site / Supplementary Visit
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Generate New Certificate Number */}
                  {showDivC && application.AssessmentTypeId !== 1 && (
                    <Grid item xs={12}>
                      <Typography variant="body2" gutterBottom>
                        Do you want to enter exiting certificate number and
                        issue date? *
                      </Typography>
                      <RadioGroup
                        row
                        value={rblCertNo}
                        onChange={(e) => handleCertNoChange(e.target.value)}
                      >
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="0"
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                    </Grid>
                  )}

                  {showLnkGenerateBtn && (
                    <Grid item xs={12} md={6}>
                      <Button
                        variant="outlined"
                        onClick={() => setShowGenerateCertModal(true)}
                      >
                        Generate New Certificate No
                      </Button>
                    </Grid>
                  )}

                  {/* Certificate Number */}
                  {showDivCertno && (
                    <Grid item xs={12}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ borderRadius: 2 }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          ℹ️ Certificate Validity Information
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 0.5 }}>
                          Please enter the actual issue date, validity of this certificate will be automatically post CEO approval i.e. 4 years from date of issue.
                        </Typography>
                      </Alert>
                    </Grid>

                      <Grid container spacing={1} sx={{mt:2}}>
                        {/* <Grid item xs={3}>
                          <TextField
                            fullWidth
                            label="Prefix"
                            value={newprefix}
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            fullWidth
                            required
                            label="Certificate No."
                            value={txtCertificateNo}
                            onChange={(e) => {
                              const value = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 5);
                              setTxtCertificateNo(value);
                            }}
                            inputProps={{ maxLength: 5 }}
                          />
                        </Grid> */}
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            required
                            label="Old Certificate No."
                            value={txtCertificateNo}
                            onChange={(e) => setTxtCertificateNo(e.target.value)}
                            placeholder="Enter old certificate number"
                          />
                        </Grid>
                        {/* Issue Date */}
                        {showDivIssueDate && (
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              required
                              type="date"
                              label="Issue Date"
                              value={txtIssueDate}
                              onChange={handleIssueDateChange}
                              InputLabelProps={{ shrink: true }}
                            />
                          </Grid>
                        )}
                      </Grid>
                      
                      {/* Amendment Date Question */}
                      <Grid item xs={12} sx={{ mt: 2 ,mb: 1}}>
                        <Paper
                          elevation={0}
                          sx={{
                            p: 2.5,
                            backgroundColor: "#e3f2fd",
                            borderLeft: "4px solid #2196f3",
                            borderRadius: 2,
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{ fontWeight: 600, mb: 2, color: "#1565c0" }}
                          >
                            Do you want amendment date?
                          </Typography>
                          <RadioGroup
                            row
                            value={amendmentChoice}
                            onChange={(e) => {
                              setAmendmentChoice(e.target.value);
                            }}
                          >
                            <FormControlLabel
                              value="Yes"
                              control={
                                <Radio
                                  sx={{
                                    color: "#2196f3",
                                    "&.Mui-checked": {
                                      color: "#1976d2",
                                    },
                                  }}
                                />
                              }
                              label="Yes"
                            />
                            <FormControlLabel
                              value="No"
                              control={
                                <Radio
                                  sx={{
                                    color: "#2196f3",
                                    "&.Mui-checked": {
                                      color: "#1976d2",
                                    },
                                  }}
                                />
                              }
                              label="No"
                            />
                          </RadioGroup>
                        </Paper>
                      </Grid>
                    </Grid>
                  )}

                  {/* To Date */}
                  {/* {showDivToDate && (
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        type="date"
                        label="Validity Till"
                        value={txtToDate}
                        onChange={(e) => {
                          setTxtToDate(e.target.value);
                          setTimeout(calculateExpectedDate, 100);
                        }}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          min: new Date().toISOString().split("T")[0],
                        }}
                        helperText="In case of extended validity, the extended validity to be punched"
                      />
                    </Grid>
                  )} */}

                  {/* Next Due Activity */}
                  {showDivNextDueActivity && (
                    <Grid item xs={12} md={6} >
                      <FormControl fullWidth required>
                        <InputLabel>Next Due Activity</InputLabel>
                        <Select
                          value={ddlNextDueActivity}
                          onChange={(e) => {
                            setDdlNextDueActivity(e.target.value);
                            setTimeout(calculateExpectedDate, 100);
                          }}
                          label="Next Due Activity"
                        >
                          <MenuItem value="0">-- Select --</MenuItem>
                          <MenuItem value="Desktop Application">
                            Desktop Application
                          </MenuItem>
                          <MenuItem value="Surveillance Application">
                            Surveillance Application
                          </MenuItem>
                          <MenuItem value="Renewal Application">
                            Renewal Application
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  )}

                  {/* Expected Date */}
                  {showDivExpectedDate && (
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        type="date"
                        label="Expected Date of Application"
                        value={txtExpectedDate}
                        onChange={(e) => setTxtExpectedDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                  )}

                  {/* Amendment Date */}
                  {/* {showDivAmendment && (
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        type="date"
                        label="Amendment Date"
                        value={txtAmendmentDate}
                        onChange={handleAmendmentDateChange}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          min: txtIssueDate || undefined,
                          max: txtToDate || undefined,
                        }}
                        helperText="Must be between Issue Date and Validity Till"
                      />
                    </Grid>
                  )} */}

                  {/* IAC Minutes Upload */}
                  {(ddlStatus != 0 && (ddlStatus !== "Close" && ddlStatus !== "Suspension" && ddlStatus !== "Abeyance" && ddlStatus !== "Debar from Reapply Certification Preparation")) && (
                    <Grid item xs={12} md={6}>
                      <FileUploadComponent
                        key={`iacFile-${fileUploadKey}`}
                        fieldName="iacFile"
                        label="Upload IAC minutes (If Applicable)"
                        orgId={localStorage.getItem("orgId") || "do"}
                        section="iac-documents"
                        accept=".pdf,.PDF"
                        maxSize={10}
                        onChange={handleFileUploadChange}
                        initialFile={uploadedIACFile}
                        localDeleteOnly={false}
                        required={false}
                        disabled={["7", "7e"].includes(stage) ? false : true}
                      />
                    </Grid>
                  )}

                  {/* Remarks */}
                  {showDivRemarks && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        multiline
                        rows={3}
                        label="Remarks"
                        value={txtRemark}
                        onChange={(e) => setTxtRemark(e.target.value)}
                      />
                    </Grid>
                  )}

                  {/* Show Cause Remarks */}
                  {showDivShowcauseRemarks && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        rows={4}
                        label="Remarks"
                        value={txtShowcauseRemarks}
                        onChange={(e) => setTxtShowcauseRemarks(e.target.value)}
                      />
                    </Grid>
                  )}

                  {/* Disciplines */}
                  {showDivDiscipline && disciplines.length > 0 && (
                    <Grid item xs={12}>
                      <Typography variant="body2" gutterBottom>
                        Discipline
                      </Typography>
                      <Grid container spacing={1}>
                        {disciplines.map((disc) => (
                          <Grid item xs={12} sm={6} key={disc.id}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedDisciplines.includes(
                                    disc.id,
                                  )}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedDisciplines([
                                        ...selectedDisciplines,
                                        disc.id,
                                      ]);
                                    } else {
                                      setSelectedDisciplines(
                                        selectedDisciplines.filter(
                                          (id) => id !== disc.id,
                                        ),
                                      );
                                    }
                                  }}
                                />
                              }
                              label={disc.disciplineName}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  )}

                  {/* Re-Assessment Type */}
                  {showDivReAssessType && (
                    <Grid item xs={12}>
                      <Typography variant="body2" gutterBottom>
                        Assessment Type
                      </Typography>
                      <RadioGroup
                        row
                        value={rbAssesstype}
                        onChange={(e) => setRbAssesstype(e.target.value)}
                      >
                        <FormControlLabel
                          value="Full Assessment"
                          control={<Radio />}
                          label="Full Assessment"
                        />
                        <FormControlLabel
                          value="Partial Assessment"
                          control={<Radio />}
                          label="Partial Assessment"
                        />
                      </RadioGroup>
                    </Grid>
                  )}

                  {/* Adverse Decision - Cooling Off Period */}
                  {showAdverseDecision && (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="body2" gutterBottom>
                          Whether Cooling off Period is applicable? *
                        </Typography>
                        <RadioGroup
                          row
                          value={rbCoolingPeriod}
                          onChange={(e) =>
                            handleCoolingPeriodChange(e.target.value)
                          }
                        >
                          <FormControlLabel
                            value="1"
                            control={<Radio />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="0"
                            control={<Radio />}
                            label="No"
                          />
                        </RadioGroup>
                      </Grid>

                      {rbCoolingPeriod === "1" && (
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            required
                            type="date"
                            label="Cooling off duration (CAB can apply afresh on or after)"
                            value={txtCollingPeriod}
                            onChange={(e) =>
                              setTxtCollingPeriod(e.target.value)
                            }
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                      )}
                    </>
                  )}

                  {/* Rejected Remarks (for 7e stage) */}
                  {showDivRejctdRmrk && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        rows={4}
                        disabled
                        label="Rejected Remark"
                        value={txtRejectedRemarks}
                      />
                    </Grid>
                  )}

                  {/* Submit Button */}
                  {/* {application?.CommunicationLetterSent === 0 &&
                    !hasDecisionData && ( */}
                    {["7", "7e", "7g", "6e"].includes(stage) && (
                      <Grid item xs={12} sx={{ textAlign: "center" }}>
                        <Button
                          variant="contained"
                          onClick={handleSubmitStatus}
                        >
                          {ddlStatus ? "Update" : "Submit"}
                        </Button>
                      </Grid>
                    )}

                  {/* Action Buttons */}
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 2,
                        justifyContent: "center",
                        mt: 2,
                      }}
                    >
                      {/* Send To Joint Director Button */}
                      {application?.CommunicationLetterSent === 1 &&
                        hasDecisionData && ["7", "7e", "7g", "12", "12a", "12b"].includes(stage) &&
                        (ddlStatus !== "Close" && ddlStatus !== "Suspension" && ddlStatus !== "Abeyance" && ddlStatus !== "Debar from Reapply Certification Preparation") && (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleOpenSendToDirector}
                            sx={{
                              textTransform: "none",
                              fontWeight: 600,
                              px: 3,
                              background:
                                "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                              boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                              "&:hover": {
                                background:
                                  "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                                boxShadow:
                                  "0 6px 20px rgba(102, 126, 234, 0.6)",
                              },
                            }}
                          >
                            Send To Joint Director
                          </Button>
                        )}
                      {((application?.CommunicationLetterSent === 1 && !hasDecisionData) ||
                       (["7"].includes(stage) && (ddlStatus === "Close" || ddlStatus === "Suspension" || ddlStatus === "Abeyance" || ddlStatus === "Debar from Reapply Certification Preparation")))&& (
                          <Button
                            variant="contained"
                            color="success"
                            onClick={() => {
                              loadDecisionData();
                              setShowDecisionModal(true);
                            }}
                          >
                            Create Decision Letter
                          </Button>
                        )}
                      {(showHlDecision && (ddlStatus !== "Close" && ddlStatus !== "Suspension" && ddlStatus !== "Abeyance" && ddlStatus !== "Debar from Reapply Certification Preparation"))&& (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            navigate(
                              `/main/do/decision-process?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}&assessmentId=${encryptText(assessmentId)}&status=${encryptText(ddlStatus)}`,
                            )
                          }
                        >
                          Create Communication Letter
                        </Button>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        )}

        {/* Password Modal for Date Submission */}
        <Dialog
          open={showPasswordModal}
          onClose={() => setShowPasswordModal(false)}
          PaperProps={{
            sx: {
              borderRadius: 3,
              minWidth: 400,
            },
          }}
        >
          <Box
            sx={{
              p: 3,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
            }}
          >
            <DialogTitle sx={{ p: 0, color: "white" }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Send application for AC Process
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                Please verify your password to continue
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent sx={{ mt: 3 }}>
            <TextField
              fullWidth
              type="password"
              label="Enter Your Password to Continue"
              value={txtPassword}
              onChange={(e) => setTxtPassword(e.target.value)}
              autoFocus
              sx={{
                "& .MuiOutlinedInput-root": {
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.1)",
                  },
                  "&.Mui-focused": {
                    boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.2)",
                  },
                },
              }}
            />
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 2 }}>
            <Button
              onClick={() => setShowPasswordModal(false)}
              sx={{
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handlePasswordSubmit}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                  boxShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
                },
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        {/* Edit Certificate Password Modal */}
        <Dialog
          open={showEditCertificateModal}
          onClose={() => setShowEditCertificateModal(false)}
          PaperProps={{
            sx: {
              borderRadius: 3,
              minWidth: 400,
            },
          }}
        >
          <Box
            sx={{
              p: 3,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
            }}
          >
            <DialogTitle sx={{ p: 0, color: "white" }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Edit Certificate
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                Please verify your password to continue
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent sx={{ mt: 3 }}>
            <TextField
              fullWidth
              type="password"
              label="Enter Your Password to Continue"
              value={editCertificatePassword}
              onChange={(e) => setEditCertificatePassword(e.target.value)}
              autoFocus
              sx={{
                "& .MuiOutlinedInput-root": {
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.1)",
                  },
                  "&.Mui-focused": {
                    boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.2)",
                  },
                },
              }}
            />
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 2 }}>
            <Button
              onClick={() => {
                setShowEditCertificateModal(false);
                setEditCertificatePassword("");
              }}
              sx={{
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleEditCertificatePasswordSubmit}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                  boxShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
                },
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        {/* Send To Joint Director Modal */}
        <Dialog
          open={showSendToDirectorModal}
          onClose={() => setShowSendToDirectorModal(false)}
          PaperProps={{
            sx: {
              borderRadius: 3,
              minWidth: 450,
            },
          }}
        >
          <Box
            sx={{
              p: 3,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
            }}
          >
            <DialogTitle sx={{ p: 0, color: "white" }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Send To Joint Director
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                Select joint director and verify with your password
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent sx={{ mt: 3 }}>
            <FormControl
              fullWidth
              required
              sx={{
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.1)",
                  },
                  "&.Mui-focused": {
                    boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.2)",
                  },
                },
              }}
            >
              <InputLabel>Select Joint Director</InputLabel>
              <Select
                value={selectedDirector}
                onChange={(e) => setSelectedDirector(e.target.value)}
                label="Select Joint Director"
                disabled={loadingDirectors}
              >
                <MenuItem value="0">--Select Joint Director--</MenuItem>
                {directorList.map((director) => (
                  <MenuItem key={director.id} value={director.id}>
                    {director.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              fullWidth
              type="password"
              label="Enter Your Password to Continue"
              value={directorPassword}
              onChange={(e) => setDirectorPassword(e.target.value)}
              required
              sx={{
                "& .MuiOutlinedInput-root": {
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.1)",
                  },
                  "&.Mui-focused": {
                    boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.2)",
                  },
                },
              }}
            />
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 2 }}>
            <Button
              onClick={() => {
                setShowSendToDirectorModal(false);
                setSelectedDirector("0");
                setDirectorPassword("");
              }}
              sx={{
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSendToDirector}
              disabled={loadingDirectors}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                  boxShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
                },
              }}
            >
              {loadingDirectors ? "Loading..." : "Send"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Generate Certificate Modal */}
        <Dialog
          open={showGenerateCertModal}
          onClose={() => setShowGenerateCertModal(false)}
        >
          <DialogTitle>Generate New Certificate No</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              type="password"
              label="Enter Your Password to Continue"
              value={txtGeneratePassword}
              onChange={(e) => setTxtGeneratePassword(e.target.value)}
              sx={{ mt: 2 }}
            />
            <Alert severity="warning" sx={{ mt: 2 }}>
              Note:- You are going to allot certificate no once no is issued it
              will not rollback.
            </Alert>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowGenerateCertModal(false)}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={handleGenerateCertificate}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        {/* Decision Process Modal */}
        <Dialog
          open={showDecisionModal}
          onClose={() => setShowDecisionModal(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              minHeight: "70vh",
            },
          }}
        >
          <Box
            sx={{
              p: 3,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
            }}
          >
            <DialogTitle sx={{ p: 0, color: "white" }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Decision Process
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                Decision Letter
              </Typography>
            </DialogTitle>
          </Box>

          <DialogContent sx={{ mt: 3, px: 4 }}>
            <Grid container spacing={3}>
              {/* Application Info */}
              {application && (
                <Grid item xs={12}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      bgcolor: "rgba(102, 126, 234, 0.05)",
                      borderRadius: 2,
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Typography variant="body2" color="textSecondary">
                          Application No
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 600 }}>
                          {application.ApplicationNo || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="body2" color="textSecondary">
                          Laboratory Name
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 600 }}>
                          {application.LaboratoryName || "N/A"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              )}

              {/* Decision Subject */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Enter Decision Letter Subject"
                  value={communicationSubject}
                  onChange={(e) => setCommunicationSubject(e.target.value)}
                  placeholder="Subject"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.1)",
                      },
                      "&.Mui-focused": {
                        boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.2)",
                      },
                    },
                  }}
                />
              </Grid>

              {/* Decision Body */}
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
                  Enter Decision Letter Body *
                </Typography>
                <Box
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    minHeight: 300,
                  }}
                >
                  <ReactQuill
                    theme="snow"
                    value={communicationBody}
                    onChange={setCommunicationBody}
                    style={{ height: 250 }}
                  />
                </Box>
              </Grid>

              {/* Action Buttons */}
              <Grid item xs={12} sx={{ textAlign: "center", mt: 4 }}>
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={handleSubmitDecision}
                    sx={{
                      px: 4,
                      textTransform: "none",
                      fontWeight: 600,
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                        boxShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
                      },
                    }}
                  >
                    Submit
                  </Button>

                  <Button
                    variant="contained"
                    color="info"
                    size="large"
                    startIcon={<Visibility />}
                    onClick={handleViewLetter}
                    sx={{
                      px: 4,
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    View Decision Letter
                  </Button>

                  {/* <Button
                    variant="contained"
                    color="success"
                    size="large"
                    startIcon={<Send />}
                    onClick={handleSendLetter}
                    sx={{
                      px: 4,
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Send Letter
                  </Button> */}
                </Box>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ px: 4, pb: 3 }}>
            <Button
              onClick={() => setShowDecisionModal(false)}
              sx={{
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Decision Password Modal */}
        <Dialog
          open={showDecisionPasswordModal}
          onClose={() => setShowDecisionPasswordModal(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
            },
          }}
        >
          <Box
            sx={{
              p: 3,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
            }}
          >
            <DialogTitle sx={{ p: 0, color: "white" }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Submit Decision
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                Enter Your Password to Continue
              </Typography>
            </DialogTitle>
          </Box>

          <DialogContent sx={{ mt: 3 }}>
            <TextField
              fullWidth
              type="password"
              label="Password"
              value={decisionPassword}
              onChange={(e) => setDecisionPassword(e.target.value)}
              autoFocus
              sx={{
                "& .MuiOutlinedInput-root": {
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.1)",
                  },
                  "&.Mui-focused": {
                    boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.2)",
                  },
                },
              }}
            />
          </DialogContent>

          <DialogActions sx={{ p: 3, pt: 2 }}>
            <Button
              onClick={() => setShowDecisionPasswordModal(false)}
              sx={{
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleDecisionPasswordSubmit}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                  boxShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
                },
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        {/* Send Letter Password Modal */}
        <Dialog
          open={showSendLetterModal}
          onClose={() => setShowSendLetterModal(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
            },
          }}
        >
          <Box
            sx={{
              p: 3,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
            }}
          >
            <DialogTitle sx={{ p: 0, color: "white" }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Send Letter
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                Enter Your Password to Continue
              </Typography>
            </DialogTitle>
          </Box>

          <DialogContent sx={{ mt: 3 }}>
            <TextField
              fullWidth
              type="password"
              label="Password"
              value={sendLetterPassword}
              onChange={(e) => setSendLetterPassword(e.target.value)}
              autoFocus
              sx={{
                "& .MuiOutlinedInput-root": {
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.1)",
                  },
                  "&.Mui-focused": {
                    boxShadow: "0 0 0 2px rgba(102, 126, 234, 0.2)",
                  },
                },
              }}
            />
          </DialogContent>

          <DialogActions sx={{ p: 3, pt: 2 }}>
            <Button
              onClick={() => setShowSendLetterModal(false)}
              sx={{
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSendLetterSubmit}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                  boxShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
                },
              }}
            >
              Send
            </Button>
          </DialogActions>
        </Dialog>

        {/* Certificate Download Dialog */}
        <CertificateDialog
          open={showCertificateDialog}
          onClose={() => setShowCertificateDialog(false)}
          scopeData={scopeData}
          scfData={scfData}
          certificateData={{
            labName: certificateMainData?.labName || "",
            address: certificateMainData?.address || "",
            additionaldata: certificateMainData?.additionaldata || "",
            applicationNo: certificateMainData?.applicationNo || "",
            certificateNumber: certificateMainData?.certificateNumber || "",
            issueDate: certificateMainData?.issuedate
              ? new Date(certificateMainData?.issuedate).toLocaleDateString(
                  "en-GB",
                )
              : "",
            validUntil: certificateMainData?.validtill
              ? new Date(certificateMainData?.validtill).toLocaleDateString(
                  "en-GB",
                )
              : "",
            amendmentDate: scopeData?.amendmentDate || "N/A",
            legalEntity: certificateMainData?.legalEntity || "",
            field: certificateMainData?.field || "",
            standard: certificateMainData?.standard || "",
            directorname: certificateMainData?.directorname || "",
            directorsignature: certificateMainData?.directorsignature || "",
            ceoname: certificateMainData?.ceoname || "",
            appId: appId,
            orgId: orgIdFromUrl,
            records: [],
          }}
          loading={loadingScopeData}
        />

        {/* Certificate Trail Dialog */}
        <Dialog
          open={showCertificateTrailModal}
          onClose={handleCloseCertificateTrail}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              fontWeight: 600,
            }}
          >
            Certificate Trail
          </DialogTitle>
          <DialogContent dividers sx={{ minHeight: "400px" }}>
            {loadingTrailData ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="300px"
              >
                <CircularProgress />
              </Box>
            ) : certificateTrailData.length === 0 ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="300px"
              >
                <Typography color="textSecondary">
                  No certificate trail data available
                </Typography>
              </Box>
            ) : (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{ fontWeight: 600, backgroundColor: "#f5f5f5" }}
                      >
                        #
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: 600, backgroundColor: "#f5f5f5" }}
                      >
                        Document Type
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: 600, backgroundColor: "#f5f5f5" }}
                      >
                        Actions
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: 600, backgroundColor: "#f5f5f5" }}
                      >
                        Date
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {certificateTrailData.map((trail, index) => (
                      <TableRow key={index} hover>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          <Box>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 500 }}
                            >
                              Scope Certificate
                            </Typography>
                            {trail.sCfURl && (
                              <Typography
                                variant="caption"
                                color="textSecondary"
                              >
                                + SCF Annexure
                              </Typography>
                            )}
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box display="flex" gap={1} flexWrap="wrap">
                            {trail.uRl && trail.uRl.startsWith("http") ? (
                              <Button
                                size="small"
                                variant="outlined"
                                color="primary"
                                startIcon={<Visibility />}
                                onClick={() =>
                                  handleViewTrailDocument(trail.uRl)
                                }
                              >
                                View Scope
                              </Button>
                            ) : (
                              <Chip
                                label="Scope: Not Available"
                                size="small"
                                color="warning"
                                variant="outlined"
                              />
                            )}
                            {trail.sCfURl &&
                              trail.sCfURl.startsWith("http") && (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  color="secondary"
                                  startIcon={<Visibility />}
                                  onClick={() =>
                                    handleViewTrailDocument(trail.sCfURl)
                                  }
                                >
                                  View SCF
                                </Button>
                              )}
                          </Box>
                        </TableCell>
                        <TableCell>{trail.date ? trail.date : "N/A"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </DialogContent>
          <DialogActions sx={{ padding: 2 }}>
            <Button
              onClick={handleCloseCertificateTrail}
              variant="contained"
              sx={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #5a67d8 0%, #5a3780 100%)",
                },
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Snackbar for notifications */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </LocalizationProvider>
  );
};

export default ACProcess;
